import { AHText, Box, ListItem, useTheme, AHIcon } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { LiveDot } from "./LiveDot";
import { StorecastDeviceItem_StorecastScreen$key } from "./__generated__/StorecastDeviceItem_StorecastScreen.graphql";

export function StorecastDeviceListItem(props: {
  storecastScreen: StorecastDeviceItem_StorecastScreen$key;
  isFirst?: boolean;
  isLast?: boolean;
  onPress(): void;
}) {
  const theme = useTheme();

  const storecastScreen = useFragment(
    graphql`
      fragment StorecastDeviceItem_StorecastScreen on StorecastScreen {
        name
        activeSession {
          id
          latencyMs
        }
      }
    `,
    props.storecastScreen
  );
  return (
    <ListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={props.onPress}
      right={
        <>
          <Box spaceRight="small">
            {storecastScreen.activeSession?.latencyMs ? (
              <Box spaceRight="small">
                <AHIcon
                  forceSize={18}
                  customColor={theme.washedText}
                  type={
                    storecastScreen.activeSession.latencyMs < 100
                      ? "signal-cellular-3"
                      : storecastScreen.activeSession.latencyMs < 200
                        ? "signal-cellular-2"
                        : "signal-cellular-3"
                  }
                />
              </Box>
            ) : null}
          </Box>
          <ListItem.NavArrow />
        </>
      }
    >
      <ListItem.Title>{storecastScreen.name}</ListItem.Title>
      <Box style={{ flex: 1 }}>
        <Box
          spaceTop="xsmall"
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <LiveDot
            color={storecastScreen.activeSession ? "positive" : "negative"}
          />
          <AHText type="detail" spaceLeft="xsmall">
            {storecastScreen.activeSession ? "Online" : "Offline"}
          </AHText>
        </Box>
      </Box>
    </ListItem>
  );
}
